__turbopack_context__.v({
  "divider": "MoreOrganizerEvents-module-scss-module__okb5Xa__divider",
  "dividerContainer": "MoreOrganizerEvents-module-scss-module__okb5Xa__dividerContainer",
  "hiddenSeoCopy": "MoreOrganizerEvents-module-scss-module__okb5Xa__hiddenSeoCopy",
  "moreOrganizerEventsContainer": "MoreOrganizerEvents-module-scss-module__okb5Xa__moreOrganizerEventsContainer",
  "subtitle": "MoreOrganizerEvents-module-scss-module__okb5Xa__subtitle",
  "title": "MoreOrganizerEvents-module-scss-module__okb5Xa__title",
  "undeterminedVenue": "MoreOrganizerEvents-module-scss-module__okb5Xa__undeterminedVenue",
});
